import { Alert, AlertDescription } from "../../../ds2/components";
import "./AppCheckErrorMessage.css";
import { CheckResponseError } from "winslow-core";
import config from "environment";

const isProd = config.environment === "production";

type AppCheckErrorMessageProps = {
    checkResponseError: CheckResponseError | undefined;
}

export const AppCheckErrorMessage = ({ checkResponseError }: AppCheckErrorMessageProps) => {

    let bestMessage = checkResponseError?.errorMessage;

    if (checkResponseError?.data?.error?.input_errors && 
        checkResponseError?.data?.error?.input_errors?.length > 0) {
        bestMessage = checkResponseError?.data?.error?.input_errors[0]?.message;
    }

    if (checkResponseError){
        console.log("[AppCheckErrorMessage] checkResponseError: ", checkResponseError);
    }

    return (
        <>
            {checkResponseError &&  
                <Alert variant="warning" className="app-check-error-message">
                    <AlertDescription>
                        {bestMessage}
                        <p/>
                        {!isProd && JSON.stringify(checkResponseError)}
                    </AlertDescription>
                </Alert>
            }
        </>
    )
}